module.exports = __webpack_public_path__ + "static/media/expo-2020-footer.06ea9bd9.svg";